<template>
  <div class="video">
    <div class="videoBox">
      <div class="video-inner">
        <div id="video-content" v-if="url">
          <video ref="myvideo" controls autoplay loop :src="url">
            <!-- <source :src="url" type="video/mp4" /> -->
          </video>
        </div>
        <i class="el-icon-close" @click="close"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["url"],
  data() {
    return {
      // videoUrl: this.url,
    };
  },
  methods: {
    close() {
      this.$emit("showVideoChange", false);
   
    },
  },
};
</script>

<style scoped lang="less">
.videoBox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(#000, 0.6);
  z-index: 1000;
  display: flex;
  .video-inner {
    width: 90vw;
    margin: auto;
    position: relative;
    video {
      width: 100%;
    }
    .el-icon-close {
      position: absolute;
      right: -2vw;
      top: -6vw;
      color: #fff;
    }
  }
}
</style>
